import { icons, images } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  .game_box {
    background: hsla(0, 0%, 0%, 0.2);
    width: calc(50% - 15px);
    display: flex;
    border-radius: 10px;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    line-height: 140%;
    flex-direction: row;
    padding: 30px;
    text-decoration: none;
  }
  .game_box.infinite_winnings {
    width: 100%;
    height: 470px;
    margin: 0 0 0 0;
    position: relative;
    flex-direction: column;
    padding: 0;
  }
  .game_box.infinite_winnings:hover .top {
    box-shadow: inset 0 0 0 1px hsl(221, 73%, 47%);
  }
  .game_box.infinite_winnings .top {
    background: url(${images.leveraged_gaming_bg_new}) center center / cover no-repeat;
    width: 100%;
    height: 470px;
    z-index: 0;
    box-shadow: inset 0 0 100px 20px hsla(0, 0%, 0%, 0.1);
    border-radius: 10px;
    position: relative;
    transition: all 0.3s ease-in-out;
  }
  .game_box.infinite_winnings .top .feature_bid-cloning {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    padding: 30px;
  }
  .game_box.infinite_winnings .top .feature_bid-cloning p {
    font-size: 1.1rem;
    text-align: right;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: nowrap;
    flex-direction: column;
    line-height: 130%;
  }
  .game_box.infinite_winnings .top .feature_bid-cloning strong {
    white-space: nowrap;
    font-weight: 800;
    text-transform: uppercase;
    display: flex;
    flex-wrap: nowrap;
    text-align: right;
    justify-content: center;
    align-items: center;
  }
  .game_box.infinite_winnings .top .feature_bid-cloning .bid_cloning_icon {
    border-radius: 50%;
    background: hsla(0, 0%, 0%, 1) url(${icons.clone_bid_icon}) center center / 26px auto no-repeat;
    width: 18px;
    height: 18px;
    padding: 26px;
    border: 1px solid hsla(0, 0%, 100%, 0.2);
    margin: 0 0 0 10px;
  }
  .game_box.infinite_winnings .top:before {
    position: absolute;
    top: calc(50% - 80px);
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    width: 100%;
    height: 100%;
    background: url(${images.leveraged_gaming_feature_title}) center center / 700px auto no-repeat;
    z-index: 0;
  }
  .game_box.infinite_winnings .bottom {
    position: absolute;
    bottom: 30px;
    background: transparent;
    flex-direction: column;
    display: flex;
    width: 100%;
    padding: 20px 40px;
  }
  .game_box .top {
    width: 100%;
    display: flex;
    min-height: 200px;
    position: relative;
    border-radius: 10px 10px 0 0;
  }
  .game_box .bottom {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background: hsl(213, 14%, 12%);
    padding: 20px;
    border-radius: 0 0 10px 10px;
  }
  .game_box.infinite_winnings .left,
  .game_box.infinite_winnings .right {
    display: flex;
    position: relative;
    z-index: 1;
  }
  .game_box.infinite_winnings .left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: center;
    justify-content: center;
    width: 95%;
    font-size: 0.8rem;
    padding: 0 0 30px 0;
  }
  .game_box.infinite_winnings .left p {
    line-height: 150%;
    font-size: 1.1rem;
  }
  .game_box.infinite_winnings .left span {
    font-weight: 700;
    display: inline;
  }
  .game_box.infinite_winnings button {
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: -0.01em;
    text-transform: uppercase;
    border-radius: 15px;
    padding: 14px 20px 14px 47px;
    margin: 0 10px 0 0;
    position: relative;
  }
  .game_box.infinite_winnings button.crypto:before {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    content: '';
    background: url(${icons.leveraged_crypto_icon}) center center / auto 15px no-repeat;
    width: 20px;
    height: 100%;
  }
  .game_box.infinite_winnings button.stocks:before {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    content: '';
    background: url(${icons.leveraged_synth_stocks_icon}) center center / auto 15px no-repeat;
    width: 20px;
    height: 100%;
  }
  .game_box.infinite_winnings button.indexes:before {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    content: '';
    background: url(${icons.leveraged_indexes_icon}) center center / auto 17px no-repeat;
    width: 20px;
    height: 100%;
  }
  .game_box.infinite_winnings button.stocks {
    padding: 14px 20px 14px 47px;
  }
  .game_box.infinite_winnings button.stocks {
    background: linear-gradient(180deg, #875cff, #7f56f1, #7750e3, #6f4ad5, #6844c8, #603eba, #5839ad, #5133a0);
  }
  .game_box.infinite_winnings button.indexes {
    padding: 14px 20px 14px 43px;
    background: linear-gradient(180deg, #00a400, #009d01, #009602, #008f03, #008804, #008104, #007b05, #007405);
  }
  .game_box.infinite_winnings button.stocks:hover {
    background: linear-gradient(180deg, #875cff, #875cff, #875cff, #875cff, #875cff, #875cff, #875cff, #875cff);
  }
  .game_box.infinite_winnings button.indexes:hover {
    padding: 14px 20px 14px 43px;
    background: linear-gradient(180deg, #00a400, #00a400, #00a400, #00a400, #00a400, #00a400, #00a400, #00a400);
  }
  .game_box.infinite_winnings button strong {
    font-weight: 800;
    display: inline-block;
    padding: 0 0 0 4px;
    white-space: nowrap;
  }
  .game_box.infinite_winnings button:last-child {
    margin-right: 0;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 1250px) {
    .game_box.infinite_winnings .left p {
      line-height: 140%;
      font-size: 1rem;
    }
  }

  @media (max-width: 1000px) {
    .game_box.infinite_winnings .top .feature_bid-cloning {
      right: auto;
      left: 50%;
      transform: translateX(-50%);
    }
    .game_box.infinite_winnings .top .feature_bid-cloning p {
      line-height: 100%;
      flex-direction: row;
      align-items: center;
      white-space: nowrap;
    }
    .game_box.infinite_winnings .top .feature_bid-cloning strong {
      padding: 0 0 0 5px;
    }
    .game_box.infinite_winnings .top .feature_bid-cloning .bid_cloning_icon {
      padding: 20px;
      background-size: 20px auto;
    }
    .game_box.infinite_winnings,
    .game_box.infinite_winnings .top {
      height: 575px;
    }
    .game_box.infinite_winnings .top:before {
      top: calc(50% - 120px);
    }
    .game_box.infinite_winnings .right {
      flex-direction: column;
    }
    .game_box.infinite_winnings button.crypto,
    .game_box.infinite_winnings button.stocks,
    .game_box.infinite_winnings button.indexes {
      width: 390px;
      padding: 14px 20px;
      margin: 0 0 10px 0;
    }
    .game_box.infinite_winnings button.crypto:before {
      left: 86px;
    }
    .game_box.infinite_winnings button.stocks:before {
      left: 35px;
    }
    .game_box.infinite_winnings button.indexes:before {
      left: 84px;
    }
  }

  @media (max-width: 800px) {
    .game_box.infinite_winnings .top:before {
      top: calc(50% - 70px);
      background-size: 550px auto;
    }
    .game_box.infinite_winnings .left p {
      line-height: 130%;
      font-size: 0.9rem;
    }
    .game_box.infinite_winnings .left {
      padding: 0 0 15px 0;
    }
  }
  @media (max-width: 600px) {
    .game_box .top {
      min-height: 150px;
    }
    .game_box.infinite_winnings .top:before {
      top: calc(50% - 50px);
      background-size: 500px auto;
    }
    .game_box.infinite_winnings .left p {
      line-height: 130%;
      font-size: 0.85rem;
    }
    .game_box.infinite_winnings .left {
      padding: 0 0 15px 0;
    }
    .game_box.infinite_winnings .bottom {
      bottom: 10px;
      padding-left: 20px;
      padding-right: 20px;
    }
    .game_box.infinite_winnings {
      height: 300px;
    }
    .game_box.infinite_winnings .top {
      height: 300px;
    }
    .game_box.infinite_winnings .top:before {
      top: calc(50% - 65px);
    }
    .game_box.infinite_winnings button {
      font-size: 1.2rem;
      letter-spacing: -0.02em;
      padding: 15px 40px;
    }
  }
  @media (max-width: 430px) {
    .game_box.infinite_winnings .top:before {
      top: calc(50% - 90px);
      background-size: 450px auto;
    }
  }
`

const developerCSS = css``

export const LeverageGamesJumboCSS = styled.div`
  width: 100%;
  cursor: pointer;
  ${designerCSS}
  ${developerCSS}
`
